import { useEffect, useEffectEvent } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { type BroadcastFormData, broadcastFormSchema } from '../validations/broadcastForm';

interface UseBroadcastFormProps {
    defaultValues: BroadcastFormData;
}

export const useBroadcastForm = ({ defaultValues }: UseBroadcastFormProps) => {
    const form = useForm<BroadcastFormData>({
        resolver: zodResolver(broadcastFormSchema),
        defaultValues,
    });

    const { reset } = form;

    const handleFormReset = useEffectEvent((values: BroadcastFormData) => {
        if (values.subject || values.body) {
            reset(values, { keepDirty: true });
        }
    });

    useEffect(() => {
        handleFormReset(defaultValues);
    }, [defaultValues]);

    return form;
};
